import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { Button, Grid, Switch } from '@material-ui/core'
import { API } from '@const'
import Table from '@tables/table'
import { EditMarqueeDialog } from '@dialogs'
import { SingleConfirmMsgDialog, ConfirmMsgDialog } from '@msg'
import * as utils from '@utils'

const COMPONENT_GROUP = 'marquee'

class MarqueePage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'MarqueePage')
        }
    }

    actions = []
    columns = [
        {
            field: 'type',
            translate: {
                dataKey: 'type',
                tranKey: 'MarqueeType',
            },
        },
        {
            field: 'pf_sub_pf_list',
            type: 'action',
            render: (rowData) => {
                return rowData.pf_sub_pf_id_list ? 
                    <Button
                        color="primary"
                        variant="contained"
                        className={this.props.classes.button}
                        onClick={() => {
                            this.singleConfirmDialog.OpenDialog({
                                type: this.t('pfSubPfList'),
                                msg: rowData['pf_sub_pf_id_list'].map((pfSubPfID) => utils.GeneratePfSubPfName(pfSubPfID)).join('\n'),
                            })
                        }}>
                        {this.t('view')}
                    </Button>
                    : ''
            },
        },
        {
            field: 'select_game',
            type: 'action',
            render: (rowData) => {
                return rowData.game_list ? 
                    <Button
                        color="primary"
                        variant="contained"
                        className={this.props.classes.button}
                        onClick={() => {
                            rowData.game_list.sort((a, b)=>{
                                return String(a).toLowerCase() === 'lobby' ? -1 : String(b).toLowerCase() === 'lobby' ? 1 : 0
                            })
                            this.singleConfirmDialog.OpenDialog({
                                type: this.t('selectGame'),
                                msg: rowData.game_list.map(item => this.handleConvertGameName(item)).join('\n'),
                            })
                        }}>
                        {this.t('view')}
                    </Button> : ''
            },
        },
        {
            field: 'start_at',
            type: 'datetime',
        },
        {
            field: 'end_at',
            type: 'datetime',
        },
        {
            field: 'language',
            render: (rowData) => {
                return Object.keys(rowData.content).length ? Object.keys(rowData.content).map(item => utils.t(`Language.${item}`)).join(', ') : ''
            },
        },
        {
            field: 'title',
        },
        {
            field: 'cycle',
            headerStyle: { minWidth: '146px' },
            render: (rowData) => {
                return rowData.cycle + ' ' + this.t('cycleOption')
            },
        },
        {
            field: 'update_by',
        },
        {
            field: 'is_active',
            type: 'action',
            render: (rowData) => {
                if (utils.checkValid(COMPONENT_GROUP + '.active')) {
                    return <Switch
                        checked={rowData.is_active}
                        onChange={(event) => {
                            this.statusConfirmDialog.OpenDialog({
                                type: 'info',
                                msg: this.t('confirmSwitchMsg'),
                                confirmParams: { checked: event.target.checked },
                                confirm: (params) => {
                                    utils.apiRequest(
                                        'post',
                                        API.MARQUEE_ACTIVE,
                                        {
                                            is_active: params.checked,
                                            id: rowData.id
                                        },
                                        (_data) => {
                                            this.statusConfirmDialog.closeDialog()
                                            this.queryData()
                                        }
                                    )
                                },
                            })
                        }}
                        value="Status"
                        color="primary"
                        inputProps={{ 'aria-label': 'Status' }}
                    />
                } else {
                    return rowData.is_active ? (<div className={this.props.classes.enable}>{utils.t('enable')}</div>) : (<div className={this.props.classes.disable}>{utils.t('disable')}</div>)
                }
            }
        }

    ]

    componentDidMount() {
        this.updateTableColumns()
        this.queryData()
    }

    updateTableColumns() {
        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.columns.push({
                field: 'edit',
                type: 'edit',
                component: this.editDialog,
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.delete')) {
            this.columns.push({
                field: 'delete',
                type: 'delete',
                apiPath: API.MARQUEE,
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.add')) {
            this.actions.push({
                icon: 'add',
                text: 'add',
                isFreeAction: true,
                onClick: () => {
                    this.editDialog.OpenDialog()
                },
            })
        }
    }

    queryData() {
        this.table.SetLoading(true)

        utils.apiRequest(
            'get',
            API.MARQUEE_LIST,
            {},
            (data) => {
                this.table.SetData(data)
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }

    handleConvertGameName(gameCode) {
        const code = String(gameCode).toLowerCase() === 'lobby' ? 'gameLobby' : gameCode
        return `${utils.t(`GameName.${code}`, '', { lng: 'zh' })} - ${utils.t(`GameName.${code}`, '', { lng: 'en' })}`
    }

    render() {
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Table
                        ownerName="MarqueePage"
                        columns={this.columns}
                        actions={this.actions}
                        onRef={(ref) => {
                            this.table = ref
                        }}
                        queryDataArgs={{
                            apiPath: API.MARQUEE_LIST,
                        }}
                    />
                    <EditMarqueeDialog
                        confirmCallback={() => {
                            this.queryData()
                        }}
                        onRef={(ref) => (this.editDialog = ref)}
                    />
                </Grid>
                <SingleConfirmMsgDialog onRef={(ref) => (this.singleConfirmDialog = ref)} />
                <ConfirmMsgDialog onRef={(ref) => (this.statusConfirmDialog = ref)} />
            </Grid>
        )
    }
}

const styles = (_theme) => {
    return {
        enable: {
            color: "#4caf50"
        },
        disable: {
            color: "#dc004e"
        }

    }
}

MarqueePage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
}

export default hoc(styles)(MarqueePage)
